module.exports = __webpack_public_path__ + "static/media/kasi.96487793.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plasticProducts/kasi.jpg
// module id = 243
// module chunks = 0